import { UserAbility } from "./Can";

import { ability as coreAbility } from "modules/core/config/permissions/ability";
import { ability as collaborationAbility } from "modules/collaboration/config/permissions/ability";
import { ability as experimentsAbility } from "modules/experiments/config/permissions/ability";
import { ability as ideasAbility } from "modules/ideas/config/permissions/ability";
import { ability as projectsAbility } from "modules/projects/config/permissions/ability";
import { ability as researchAbility } from "modules/research/config/permissions/ability";
import { ability as insightsAbility } from "modules/insights/config/permissions/ability";
import { ability as strategyAbility } from "modules/strategy/config/permissions/ability";
import { ability as decisionsAbility } from "modules/strategy/config/permissions/ability";
import { ability as governanceAbility } from "modules/governance/config/permissions/ability";

export const ability = {
  ...coreAbility,
  ...collaborationAbility,
  ...experimentsAbility,
  ...ideasAbility,
  ...projectsAbility,
  ...researchAbility,
  ...insightsAbility,
  ...strategyAbility,
  ...decisionsAbility,
  ...governanceAbility,
  user: {
    read: ["all"],
    create: ["master", "executive", "program_manager", "administrator"],
    update: ["master", "executive", "program_manager", "administrator"],
    delete: ["master", "executive", "program_manager", "administrator"],
    config: ["master", "executive", "program_manager", "administrator"]
  }
} as UserAbility;
